import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { TableCellBone } from '../../atoms/TableCellBone/TableCellBone';

interface TableRowBoneProps {
    /** Nombre de colonnes */
    columns?: number;
    /** Est-ce une ligne d'en-tête */
    isHeader?: boolean;
    /** Espacement entre colonnes */
    gap?: string;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const TableRowBone: React.FunctionComponent<TableRowBoneProps> = function ({
    columns = 4,
    isHeader = false,
    gap = '16px',
    sx = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                gap,
                marginBottom: '16px',
                ...sx,
            }}
        >
            {Array.from({ length: columns }).map((_, colIndex) => (
                <TableCellBone
                    key={`table-cell-${columns}-${colIndex + 1}`}
                    isHeader={isHeader}
                />
            ))}
        </Box>
    );
};
